(function () {
  "use strict";

  angular
    .module('trainerWebApp.services')
    .factory('xlsValidator', xlsValidator);

  function xlsValidator() {

    return {
      setErroredRows: function (params) {
        var rows = params.rows;
        var fields = params.fields;
        var rowOffset = params.rowOffset;
        var indexes = {};
        var requiredCustomFields = {};

        var field;
        for (var i = 0, c = fields.length; i < c; i++) {
          field = fields[i];
          indexes[field.id] = field.columnIdx;

          if (field.required && field.customField)
            requiredCustomFields[field.columnIdx.toString()] = true;
        }

        var processedEmails = {};
        var processedUsernames = {};
        var email, first, last, username, password;
        var anyErrors = false;

        for (var i = 0, c = rows.length; i < c; i++) {
          var row = rows[i];
          delete row.$errors;
          email = (row[indexes.email] || '').trim().toLowerCase();
          first = (row[indexes.firstName] || '').trim();
          last = (row[indexes.lastName] || '').trim();
          username = (row[indexes.username] || '').trim().toLowerCase();
          password = (row[indexes.password] || '');

          if (email && processedEmails[email] >= 0)
            addError(row, indexes.email, "This email address is already present on row " + processedEmails[email]);

          if (username && processedUsernames[username] >= 0)
            addError(row, indexes.username, "This username is already present on row " + processedUsernames[username]);

          if (email && !emailIsValid(email))
            addError(row, indexes.email, "This email address is not valid");

          if (email || !username) {
            addError(row, indexes.email, isPresent(email, "Email") || isShort(email, "Email", 254));
          } else {
            addError(row, indexes.username, isPresent(username, "Username"));
            addError(row, indexes.password, isPresent(password, "Password"));
          }
          addError(row, indexes.password, validatePassword(password));
          addError(row, indexes.password, isShort(password, "Password", 35));

          addError(row, indexes.firstName, isPresent(first, "First Name") || isShort(first, "First Name", 35));
          addError(row, indexes.lastName, isPresent(last, "Last Name") || isShort(last, "Last Name", 35));

          // TODO - to support required custom fields
          // General Error - required custom fields and no col idx, error
          // Error - required custom field has columnIdx, but row[field.columnIdx] has no text, or has > 200 chars

          processedEmails[email] = i + rowOffset;
          processedUsernames[username] = i + rowOffset;
          anyErrors = anyErrors || row.$errors;
        }

        return anyErrors;
      }
    };

    function emailIsValid(email) {
      var emailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
      return emailRegex.test(email);
    }

    function isPresent(data, fieldName) {
      if (!data || data.length === 0)
        return fieldName + " is required";

      return null;
    }

    function isShort(data, fieldName, maxLen) {
      if (data && data.length > maxLen)
        return fieldName + " is too long, please limit " + fieldName + " to " + maxLen + " characters";

      return null;
    }

    function validatePassword(data) {
      var pwordRegex = new RegExp('(?=.*[A-Z])(?=.*[^A-Za-z\\d])(?=.*\\d)(?=.*[a-z]).{8}');
      if (data && !pwordRegex.test(data)) {
        return 'Must contain at least 8 characters, one uppercase and lowercase letter, number, and symbol';
      }
      return null;
    }


    function addError(row, fieldIdx, error) {
      if (!error) return;
      if (!row.$errors)
        row.$errors = {};

      row.$errors[fieldIdx] = error;
    }
  }

})();
